// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__ogF3f","tab":"ProcedureTabs_tab__16G0p"};